import {Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {HrFormToolbarEvents} from '../../base-form/hr-form-toolbar-events';
import {HrTranslateKey} from '../../translate/hr-translate-key';
import {HrBaseListPageNew} from "../../base-form/hr-base-list-page-new";
import {UiConfirmationDialogService, UiToastMessageService} from "ui-shared";
import {Observable} from "rxjs";

@Component({
    selector: 'hr-toolbar',
    templateUrl: './hr-toolbar.component.html',
})
export class HrToolbarComponent implements OnInit, OnChanges {
    @Input() addButtonDisabled?: boolean;
    @Input() blockButtonDisabled?: boolean;
    @Input() editButtonDisabled: boolean;
    @Input() idPrefix: string;
    @Input() removeButtonDisabled: boolean;
    @Input() copyButtonDisabled: boolean;
    @Input() viewButtonDisabled: boolean;
    @Input() addButtonShow?: boolean;
    @Input() blockButtonShow?: boolean;
    @Input() editButtonShow?: boolean;
    @Input() editButtonLabel?: string;
    @Input() viewButtonLabel?: string;
    @Input() removeButtonShow?: boolean;
    @Input() copyButtonShow?: boolean;
    @Input() viewButtonShow?: boolean;
    @Input() form: HrFormToolbarEvents;
    @Input() listComponent: HrBaseListPageNew<any>;
    @Input() onRemoveCallback: ()=>Observable<any>;
    @Input() deletedMessagePrefix: string;

    @Output() onBlock: EventEmitter<any> = new EventEmitter();
    inputId: string;

    confirmationDialogService = inject(UiConfirmationDialogService);
    toastMessageService = inject(UiToastMessageService);

    constructor() {}

    ngOnInit(): void {
        this.inputId = this.idPrefix;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.idPrefix != null && changes.idPrefix.previousValue !== changes.idPrefix.currentValue) {
            this.setInputId(changes.idPrefix.currentValue);
        }
    }

    private setInputId(idPrefix: string) {
        this.inputId = idPrefix;
    }
    openAddFormEvent() {
        this.form.openAddForm();
    }

    openCopyFormEvent() {
        this.form.openCopyForm();
    }

    openEditFormEvent() {
        this.form.openEditForm();
    }
    openViewFormEvent() {
        this.form.openViewForm();
    }

    openRemoveFormEvent() {
        if (this.onRemoveCallback){
            this.openRemoveForm();
            return;
        }
        this.form.openRemoveForm();
    }

    private openRemoveForm() {
        if (!this.listComponent.selectedItem) {
            return;
        }
        this.confirmationDialogService.showDeleteConfirmDialog(() => {
            this.onRemoveCallback().subscribe(() => {
                this.listComponent.clearSelectedItem();
                this.listComponent.refreshTable();
                this.toastMessageService.showDeleteSuccess(this.deletedMessagePrefix);
            });
        });
    }

    block() {
        this.onBlock.emit();
    }

    public get hrKey(): typeof HrTranslateKey {
        return HrTranslateKey;
    }
}
